
import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cajaChicaSustentoService {

    /******* QUERIES ******/



    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-sustento/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async listaDocumentoSustento(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-sustento/documento?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };



    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-sustento/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-sustento/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-chica-sustento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica-sustento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


}

export default new cajaChicaSustentoService();